import * as types from "../constants/paymentConstant";
const initialState = {
  checkoutResponse: null,
  paymentIntent: null,
  plans: [],
  proration: null,
  orders: [],
  cancelSubscription: null
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PAYMENT_METHOD_AND_CHECKOUT:
      return { ...state, checkoutResponse: action.payload };
    case types.SUBSCRIPTION_UPGRADE:
      return { ...state, checkoutResponse: action.payload };
    case types.CREATE_PAYMENT_INTENT:
      return { ...state, paymentIntent: action.payload };
    case types.GET_PLANS:
      return { ...state, plans: action.payload };
    case types.GET_PRORATION:
      return { ...state, proration: action.payload };
    case types.GET_ORDERS:
      return { ...state, orders: action.payload };
    case types.CANCEL_SUBSCRIPTION:
        return { ...state, cancelSubscription: action.payload };
    default:
      return state;
  }
};
export default paymentReducer;
